<template>

  <modal :loading="loading" titulo="Gestão de Ato" class="modal-detalhes-ato" id="detalhes-ato" :fechar="true" @close="close">

    <template #actions>

    </template>

    <template>

      <div id="aba-dados-principais">
        <card>
          <div class="row gutters-xs ato">

            <v-input :default="true" v-model="form.custasManual"
                     title="Ao marcar essa opção como sim, este ato não terá mais seus valores cálculados pelo sistema em nenhuma operação"
                     label="Bloquear alterações nos emolumentos e custas deste ato?" type="radio" :class="form.tipoServico && form.tipoServico.opcoes && form.tipoServico.opcoes.opcionalIncluirRelatorioIR ? 'col-6 text-red' : 'col-12 text-red'"/>

            <v-input type="radio" label="Incluir no relatório do indicador real?"
                     v-model="form.dto.incluirAtoRelatorioIR" :default="false" class="col-4"  v-if="form.tipoServico && form.tipoServico.opcoes && form.tipoServico.opcoes.opcionalIncluirRelatorioIR && form.ficha.livro !== 'REGISTRO_AUXILIAR'" />

            <div class="w-100" />

            <template>
              <v-input :error="validation.tipoServico" :options="tiposServico"
                       @change="changeTipo" class="col-5" label="Tipo de Ato" type="v-select"
                       v-model="form.tipo_id"/>
              <v-input :error="validation.titulo" class="col-4" label="Titulo"
                       type="text" v-model="form.titulo"/>
              <v-input :error="validation.codigo" class="col-3" label="Código"
                       type="number" v-model="form.codigo"/>
            </template>

            <div class="w-100"></div>
            <v-input :error="validation.registro" class="col-4" label="Registro"
                     type="datetime-local" v-model="form.registro" :max="today" @blur="checkDate('registro')"/>

            <v-input :error="validation.selado" class="col-4" label="Selagem"
                     type="datetime-local" v-model="form.selado" :max="today" @blur="checkDate('selado')"/>

            <div class="col">
              <label>Protocolo</label>
              <buscar-protocolos :multiple="false" @selecionar="selecionar($event)"
                                 :dominio="dominio"
                                 :tipoProtocoloSimples="true" ref="buscarProtocolos" v-if="!form.protocolo"/>
              <div class="row gutters-xs" v-else>
                <v-input class="col form-group">
                  <input class="form-control form-control-xs" readonly type="text" v-model="this.codigoProtocolo"/>
                </v-input>

                <div class="col-auto">
                  <button :disabled="false" @click="selecionar(null)"
                          class="btn btn-outline-secondary btn-xs" title="Remover" type="button">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <template v-if="form.legado && form.id">
              <div class="w-100"/>
              <card class="w-100">
                <div class="row gutters-xs">
                  <v-input v-model="form.livro" type="select" :options="tipoStatus" :disabled="!!form.ficha"
                           :required="true" placeholder="Tipo" style="width: 21%" />
                  <buscar-fichas :livro="selecionadoFicha.livro" :status="selecionadoFicha.status" ref="buscarFichas"
                                 @selecionar="selecionarFichas" @pesquisando="pesquisandoFicha" :multiplos="false" :multiple="false" class="col-9" :full="true"/>

                  <div class="row gutters-xs col">
                    <div class="col-auto">
                      <button :disabled="false" @click="selecionarFichas(null)"
                              class="btn btn-outline-secondary btn-xs" title="Remover" type="button">
                        <i class="fal fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </card>
            </template>

            <div class="w-100"/>
            <card v-if="!loading" class="w-100" titulo="Minuta">

              <template #acoes v-if="form.tipo_id">

                <v-button title="Gerar texto com base na configuração"
                          :button="false" :popover="true" position="dropleft"
                          :run="gerarTexto" class="icon float-right pointer">
                  GERAR TEXTO
                </v-button>

                <v-button :button="false" :run="consultarModelos" class="icon float-right pointer mr-3">
                  CONSULTAR MODELOS
                </v-button>

                <v-button :button="false" :run="consultarQualificacoes" class="icon float-right pointer mr-3">
                  QUALIFICAÇÕES
                </v-button>

              </template>
              <v-input v-model="form.texto"
                       ref="editorminuta"
                       type="classic-editor" class="col p-0 pb-2" />
            </card>

            <div class="w-100"></div>
            <v-input v-if="ficha.imovelUniao" class="col mb-3"
                     v-model="form.numeroCat" type="mask" :masks="['###################']" label="Número da CAT" />

            <div class="w-100"></div>
            <vinculo-guia-tribunal class="w-100" :item="form" :edicao="true" tipo="ato" />

            <div class="col-12">
              <card titulo="DOI" v-if="possuiAreaDoi">
                <v-input :default="false" v-model="form.doi.gerarDoi" label="Gerar DOI?" type="radio" />
              </card>
            </div>

            <div class="w-100"></div>
            <div class="col-12" v-if="exibirInformacaoLivro">
              <card titulo="Informações do Livro">

                <template #info v-if="rtdpjMultiplosLivros">
                  <i class="fal fa-exclamation-circle pointer icon" title="Texto de Ajuda" @click.stop="exibirAjuda(textoAjudaLivro)" ></i>
                </template>

                <div class="row gutters-xs w-100">

                  <v-input :error="validation.quantidadeFolhas" :class="colsInformacaoLivro" label="Quant. de Folhas" title="Quantidade de Folhas"
                           type="number" v-model="form.quantidadeFolhas"/>
                  <div class="w-100" v-if="rtdpjMultiplosLivros" />

                  <v-input :error="validation.numeroControleLivro" :class="colsInformacaoLivro" :label="labelNumeroControleLivro"
                           type="number" v-model="form.numeroControleLivro"/>

                  <v-input :error="validation.numeroControleFolha" :class="colsInformacaoLivro" label="Folha Inicial"
                           type="number" v-model="form.numeroControleFolha"/>

                  <v-input :error="validation.ladoPaginaControleInicial" :class="colsInformacaoLivro" label="Lado Inicial"
                           v-if="rtdpjFrenteVerso"
                           type="select" :options="[{id: 'F', nome: 'F'}, {id: 'V', nome: 'V'}]" v-model="form.ladoPaginaControleInicial"/>

                  <v-input :class="colsInformacaoLivro" label="Número do Livro Final"
                           v-if="rtdpjMultiplosLivros"
                           type="number" v-model="form.numeroControleLivroFinal"/>

                  <v-input :error="validation.numeroControleFolhaFinal" :class="colsInformacaoLivro" label="Folha Final"
                           type="number" v-model="form.numeroControleFolhaFinal"/>

                  <v-input :error="validation.ladoPaginaControleFinal" :class="colsInformacaoLivro" label="Lado Final"
                           v-if="rtdpjFrenteVerso"
                           type="select" :options="[{id: 'F', nome: 'F'}, {id: 'V', nome: 'V'}]" v-model="form.ladoPaginaControleFinal"/>

                </div>

              </card>
            </div>

            <template v-if="form.tipo_id">
              <div class="w-100" v-if="updateAreas">
                <component  v-for="area in areas" :item="form" :ato="form" :ficha="ficha" :protocolo="form.protocolo"
                            @checklist="atualizarChecklists()" :edicao="true" @change-editor="changeEditor"
                            :key="area.id" :is="area.id" :ref="area.id" :id="area.id" :checklist="checklistEnvolvidos">
                </component>
              </div>
            </template>

            <div class="w-100"></div>

            <responder-checklist :documentos="documentos" v-if="form && form.id && checklist && checklist.length"
                                 :checklists="checklist"
                                 :permitir-edicao="true"
                                 :dto="form"
                                 ref="checklist"
                                 entidade="ato"
            />

          </div>
        </card>
      </div>
    </template>

    <template #footer>
      <button @click.prevent="close()" class="btn btn-outline-secondary mr-auto" type="button">Fechar</button>
      <v-button v-if="!$root.isAuditorOnly" :run="salvar" class="btn-outline-primary" :disabled="realizandoBusca">Salvar & Continuar</v-button>
    </template>

  </modal>

</template>

<script>


import ChecklistProcessamentoBusiness from "@/business/ChecklistProcessamentoBusiness.js";
import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness";
import FrontBusiness from "@/business/FrontBusiness.js";
import AtoLegadoBusiness from "@/business/indicadores/AtoLegadoBusiness.js";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness.js";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import RegistroAuxiliarBusiness from "@/business/indicadores/RegistroAuxiliarBusiness";
import textoFormatado from "@/business/livros/copiladores/textoFormatado.js";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import ProtocoloDocumentoBusiness from "@/business/protocolo/ProtocoloDocumentoBusiness";
import RegraCustasBusiness from "@/business/RegraCustasBusiness.js";
import Utils from "@/commons/Utils.js";
import BuscarProtocolos from "@/components/BuscarProtocolos";
import TagList from "@/components/Form/TagList";
import Card from "@/components/Layout/components/Card.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal";
import VinculoGuiaTribunal from "@/components/Guia/VinculoGuiaTribunal.vue";
import ModalSelecionarModeloTextual from "@/views/Administracao/modulos/modelo-textual/ModalSelecionarModeloTextual";
import tipoServicoBusiness from "@/views/Administracao/modulos/tipo-servico/business";
import BensGarantias from "@/views/Protocolo/Atos/Ato/BensGarantias.vue";
import CancelarRestricoes from "@/views/Protocolo/Atos/Ato/CancelarRestricoes";
import CancelarRestricoesNaoRegistradas from "@/views/Protocolo/Atos/Ato/CancelarRestricoesNaoRegistradas";
import ReativarRestricoes from "@/views/Protocolo/Atos/Ato/ReativarRestricoes";
import Documentos from "@/views/Protocolo/Atos/Ato/Documentos.vue";
import EditarIndicadorReal from '@/views/Protocolo/Atos/Ato/EditarIndicadorReal'
import EditarRegistroAuxiliar from '@/views/Protocolo/Atos/Ato/EditarRegistroAuxiliar'
import InformacoesRegulatorias from '@/views/Protocolo/Atos/Ato/InformacoesRegulatorias'
import Envolvidos from "@/views/Protocolo/Atos/Ato/Envolvidos";
import ModalInserirQualificacao from "@/views/Protocolo/Atos/Ato/ModalInserirQualificacao";
import MultiplasCobrancas from "@/views/Protocolo/Atos/Ato/MultiplasCobrancas";
import Recolhimentos from "@/views/Protocolo/Atos/Ato/Recolhimentos.vue";
import RestricoesCard from "@/views/Protocolo/Atos/Ato/Restricoes/RestricoesCard";
import business from "@/views/Protocolo/Atos/business.js";
import ModalCompararTexto from "@/views/Protocolo/Atos/ModalCompararTexto";
import moment from "moment";
import protocoloBusiness from "@/business/protocolo/ProtocoloBusiness";
import PapelBusiness from "@/business/PapelBusiness";
import ModalTexto from "@/components/ModalTexto.vue";

export default {

  name: "DetalhesAto",
  components: {
    VinculoGuiaTribunal,
    Modal,
    BuscarProtocolos,
    CardTable,
    Card,
    TagList,
    /** ÁREAS **/
    CancelarRestricoes, ReativarRestricoes, Envolvidos,
    RestricoesCard, EditarIndicadorReal,
    EditarRegistroAuxiliar, Recolhimentos,
    CancelarRestricoesNaoRegistradas, MultiplasCobrancas, Documentos, BensGarantias,
    InformacoesRegulatorias,
    ResponderChecklist: () => import("@/components/Protocolo/ResponderChecklist.vue"),
    Doi: () => import("@/views/Protocolo/Atos/Ato/DOI"),
    LivroEstrangeiro: () => import("@/views/Protocolo/Atos/Ato/LivroEstrangeiro.vue"),
    Emolumentos: () => import("@/views/Protocolo/Atos/Ato/Emolumentos"),
    CardAtosIndicador: () => import("@/components/IndicadorReal/Detalhes/CardAtosIndicador"),
    NotificacaoItem: () => import("@/views/Notificacao/gerenciarNotificacao/Notificacao"),
  },

  restricoesDisponiveis: [],


  modal: {
    width: 1100,
    escapable: false
  },

  props: {
    id: String,
    protocoloId: String,
    ficha: Object,
  },

  async created() {
    await ChecklistProcessamentoBusiness.init();
    this.checklists = window.checklists;
    this.listas = window.listas;

    await TipoServicoBusiness.getByDominioSimplesTodos(this.dominio).then(l => l.forEach(n => {
      n.opcoes?.livros?.forEach(l => {
        if (l === this.ficha.livro) this.tiposServico?.push(n)
      });
    }));

    let dto = {
      atosVirtuais: [],
      envolvidos: [],
      tipoServico: {opcoes: {}},
      legado: true,
      ordem: 99999,
      dto: {camposAdicionais: {}, valoresBaseCalculo: {}},
      doi: {gerarDoi: false}
    };

    if (this.id) {

      let promises = [];

      if (this.protocoloId) {
        promises.push(ProtocoloDocumentoBusiness.listar(this.protocoloId).then(l => this.documentos = l));
      }

      dto = await AtoBusiness.getById(this.protocoloId, this.id).catch(e => {
        FrontBusiness.showError('', e.message)
        this.close()});

      await Promise.all(promises);

      dto.isento = !!dto.isento;
      dto.diferido = !!dto.diferido;
      dto.diferimentoRecebido = !!dto.diferimentoRecebido;

      if(dto?.id){
        dto.envolvidos = dto.envolvidos || [];
        dto.tipoServico = dto.tipoServico || {};
        dto.tipo_id = dto.tipoServico?.id || [];
        if(dto.registro){
          dto.registro = this.$moment(dto.registro).format('YYYY-MM-DDTHH:mm:ss')
        }

        if(dto.selado){
          dto.selado = this.$moment(dto.selado).format('YYYY-MM-DDTHH:mm:ss')
        }
        dto.dto = dto.dto || {};
        dto.dto.configuracaoRestricao = dto.dto.configuracaoRestricao || {};
        dto.dto.restricoesCanceladas = dto.dto.restricoesCanceladas || [];
        dto.legado = dto.legado === null ? true : dto.legado;
        dto.dto.incluirAtoRelatorioIR = dto.dto.incluirAtoRelatorioIR || false;


        await this.setAreas(dto);

      }
    }
    dto.doi = this.getDoiDTO(dto);
    dto.dto.camposAdicionais = await this.getCamposAdicionais(dto);
    dto.dto.indicador = dto.dto.indicador || {};
    dto.ficha = this.ficha || {};
    this.$set(this, 'form', dto);

    if (this.$refs.buscarFichas) {
      this.$refs.buscarFichas.individual = this.ficha;
      this.$refs.buscarFichas.strId = this.ficha.id;
    }

    // await this.getProcurador();
    await this.tratarChecklist();

    const dtoInicial = await this.gerarDto();
    this.assinatura_old = {
      codigo: dtoInicial?.codigo,
      titulo: dtoInicial?.titulo,
      texto: dtoInicial?.texto
    };
    this.$nextTick(() => {
      setTimeout(() => {
        this.verificarAlteracoes(true);
      }, 150);
    });
    this.$set(this, 'loading', false);
  },

  watch: {
    envolvidos: function () {
      this.atualizarCardLivroEstrangeiro();
    },
    papeisEnvolvidos: function () {
      this.atualizarCardLivroEstrangeiro();
    }
  },

  computed: {
    codigoProtocolo(){
        return protocoloBusiness.getCodigoProtocolo(this.form.protocolo);
    },

    papeis() {
      const proibidos = this.form?.tipoServico?.opcoes?.papeisProibidos || [];
      return this.$root.papeis.filter(p => !proibidos.includes(p.id))
    },
    envolvidos() {
      return this.form.envolvidos;
    },
    papeisEnvolvidos() {
      return this.form.envolvidos.map(e => e.papel);
    },
    possuiAreaDoi() {
      return this.areas.filter(a => a.id === 'doi').length > 0 && !this.form.tipoServico?.opcoes?.doiOpcional && this.form.tipo_id != null;
    },
    today(){
      return new Date().toISOString().split(".")[0];
    },
    tipoStatus() {
      const livro = IndicadorBusiness.getLivro(this.ficha?.livro);
      return [{
        id:  livro.id,
        nome: livro.nome,
        livro:  livro.id,
        status: 'ABERTA'
      }, this.ficha?.livro == 'TRANSCRICAO' ? null : {
        id: "PRE_"+livro.id,
        nome: "Pré-"+livro.nome,
        livro:  livro.id,
        status: 'PENDENTE'
      }].filter(t => t);
    },
    selecionadoFicha() {
      return this.tipoStatus.find(e => e.id === this.form.livro) || {};
    },

    realizandoBusca() {
      if (this.form.legado && this.form.id) {
        return this.pesquisando;
      } else {
        return false
      }
    },

    dominio() {
      return IndicadorBusiness.getDominioByLivro(this.ficha.livro)
    },

    exibirInformacaoLivro() {
      return this.$root.config.livros.livroRegistroIntegral.rtdpjControleFolha && ['REGISTRO_PJ', 'REGISTRO_TD'].includes(this.ficha?.livro);
    },

    rtdpjFrenteVerso() {
      return this.$root.config.livros.livroRegistroIntegral.rtdpjFrenteVerso;
    },

    rtdpjMultiplosLivros() {
      return this.$root.config.livros.livroRegistroIntegral.rtdpjMultiplosLivros;
    },

    colsInformacaoLivro() {
      if (this.rtdpjMultiplosLivros) {
        return 'col-4'
      }
      return 'col-2'
    },

    labelNumeroControleLivro() {
      if (this.rtdpjMultiplosLivros) {
        return 'Número do Livro Inicial'
      }
      return 'Número do Livro'
    },

  },

  data() {
    return {
      form: {
        atosVirtuais: [],
        envolvidos: [],
        tipoServico: {opcoes: {}},
        dto: {incluirAtoRelatorioIR: false, doi: {gerarDoi: false}, camposAdicionais: {}, valoresBaseCalculo: {}},

      },
      form_old: {},
      assinatura_old: {},
      papeisComFracao: ['ADQUIRENTE', 'TRANSMITENTE', 'DEVEDOR','GARANTIDOR', 'CREDOR', 'CEDENTE', 'CESSIONARIO', 'PROMITENTE_VENDEDOR', 'PROMITENTE_COMPRADOR', 'FIEL_DEPOSITARIO'],
      tiposServico: [],
      checklists: [],
      documentos: [],
      listas: [],
      indices: {},
      checklist: [],
      checklistEnvolvidos: [],
      validation: {},
      mostrarDataVencimento: false,
      areas: [],
      atualizarAreas: true,
      loading : true,
      areasPossiveis: ['envolvidos','cancelar-restricoes-nao-registradas', 'cancelar-restricoes', 'reativar-restricoes', 'restricoes-card', 'card-atos-indicador', 'livro-estrangeiro', 'doi', 'emolumentos', 'editar-indicador-real', 'multiplas-cobrancas', 'recolhimentos', 'documentos', 'bens-garantias', 'informacoes-regulatorias'],
      areasPossiveisRegistroAuxiliar: ['envolvidos','cancelar-restricoes-nao-registradas', 'cancelar-restricoes', 'reativar-restricoes', 'restricoes-card', 'card-atos-indicador', 'doi', 'emolumentos', 'editar-registro-auxiliar', 'multiplas-cobrancas', 'bens-garantias', 'informacoes-regulatorias'],
      alterouFicha: false,
      pesquisando: false,
      updateAreas: null,
      textoAjudaLivro:
        `<p style="text-align: justify">
          Caso seja necessário alterar o registro para que ele não ocupe mais de um livro, a serventia deverá remover o número do livro final. Dessa forma, permanecerão apenas as informações do livro inicial e das folhas inicial e final (e dos lados, caso aplicável), considerando que o registro estará em um único livro.
          Caso seja necessário alterar o registro para que ele ocupe mais de um livro, a serventia deverá informar o número do livro final. Nesse caso, deverão ser preenchidos os dados do livro inicial, da folha inicial do livro inicial e da folha final do livro final, assim como os lados das respectivas folhas, caso utilizado.
        </p>`
    }
  },

  methods: {
    exibirAjuda(textoAjuda) {
      FrontBusiness.openModal(ModalTexto, {texto:textoAjuda, titulo: 'Texto de Ajuda'});
    },
    async setAreas(ato) {
      this.updateAreas = null;
      ato.documentos = ato.documentos || [];
      ato.indicadorGarantias = ato.indicadorGarantias || [];
      ato.tipoServico = ato.tipoServico || this.form.tipoServico;
      ato.livro = ato.livro || this.ficha.livro;
      ato.dto = ato.dto || {};
      ato.dto.valoresBaseCalculo = ato.dto?.valoresBaseCalculo || {};
      ato.dto.configuracaoRestricao = ato.dto.configuracaoRestricao || {};
      ato.dto.restricoesCanceladas = ato.dto.restricoesCanceladas || [];
      ato.dto.restricoesReativadas = ato.dto.restricoesReativadas || [];
      ato.dto.restricoesCanceladasDisponiveis = ato.dto.restricoesCanceladasDisponiveis || [];
      ato.dto.incluirAtoRelatorioIR = ato.dto.incluirAtoRelatorioIR || false;
      ato.dto.restricoes = ato.dto.restricoes || [];
      switch (this.ficha.livro) {
        case 'REGISTRO_AUXILIAR':
          ato.registroAuxiliar = ato.registroAuxiliar || this.form.ficha;
          if (!ato.id || !ato.dto.restricoes.length) {
            ato.dto.restricoes = await RegistroAuxiliarBusiness.restricoesVigentes(ato.registroAuxiliar.id);
          }
          if (!ato.id) {
            ato.dto.restricoesCanceladasDisponiveis = await RegistroAuxiliarBusiness.restricoesCanceladas(ato.registroAuxiliar.id);
          }
          break;
        case 'MATRICULA':
        case 'TRANSCRICAO':
          ato.indicadorReal = ato.indicadorReal || this.form.ficha;
          if (!ato.id || !ato.dto.restricoes.length) {
            ato.dto.restricoes = await IndicadorRealBusiness.restricoesVigentes(ato.indicadorReal.id);
          }
          if (!ato.id) {
            ato.dto.restricoesCanceladasDisponiveis = await IndicadorRealBusiness.restricoesCanceladas(ato.indicadorReal.id);
          }
          break;
        default:
          ato.indicador = ato.indicador || this.form.ficha;
          break;
      }
      if ((ato.dto.restricoes || []).length && ato.id) {
        ato.dto.restricoes = (ato.dto.restricoes || []).filter(e => e.atoId !== ato.id)
      }
      ato.doi = this.getDoiDTO(ato);
      ato.dto.camposAdicionais = await this.getCamposAdicionais(ato);
      this.$set(this, 'form', ato);
      let areas = business.areasAto(ato);
      this.filtrarAreas(areas);
      this.updateAreas = this.$moment();
    },

    filtrarAreas(areas) {
      let dominio = IndicadorBusiness.getDominioByLivro(this.ficha?.livro) || this.form?.protocolo?.dominio;
      if (this.$root.getPermission({id: 'PERMITIR_ALTERAR_PROTOCOLO_REGISTRADO', dominio: dominio})) {
        this.areasPossiveis.push('notificacao-item');
        this.areasPossiveisRegistroAuxiliar.push('notificacao-item');
      }
      areas = areas.filter(a => ((this.ficha.livro !== 'REGISTRO_AUXILIAR' && this.areasPossiveis.includes(a.id))
        || (this.ficha.livro === 'REGISTRO_AUXILIAR' && this.areasPossiveisRegistroAuxiliar.includes(a.id))));
      this.$set(this, 'areas', areas)

    },

    close(){
      FrontBusiness.closeModal(this.alterouFicha)
    },

    selecionar(protocolo) {
      this.$set(this.form, 'protocolo', protocolo ? protocolo[0] : null);
    },

    remover(idx, lista) {
      this.$nextTick(() => {
        this.form[lista].splice(idx, 1);
      });
    },

    async changeTipo(id) {
      let tipoServico = this.tiposServico.find(e => e.id === id);
      this.$set(this.form, 'tipoServico', tipoServico);
      //this.$set(this.form, 'titulo', tipoServico?.opcoes?.titulo);
      this.$set(this, 'areas', []);
      await this.setAreas(this.form);
    },

    showError(e) {
      FrontBusiness.fullErrorHandler(this, e, '#formulario-ato');
      return null;
    },

    validarRestricoes(dto) {
      let retorno = true;
      let erroPapelEnvolvido = tipoServicoBusiness.verificarPapeisEnvolvidos(dto.envolvidos, dto.tipoServico?.opcoes?.papeisObrigatorios);
      if (erroPapelEnvolvido) {
        FrontBusiness.showError('', erroPapelEnvolvido);
        retorno = false;
      }

      if(dto.tipoServico?.opcoes?.restricaoOpcional){
        if(!dto.tipoServico?.opcoes?.criarRestricao){
          FrontBusiness.showError('', `Necessário configurar as restrições para o tipo de ato selecionado`);
          retorno = false;
        }

        const restricoesBase = ['ONUS', 'ACAO', 'INDISPONIBILIDADE'].filter(r => dto?.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes(r));
        if (restricoesBase.length > 0) {
          const papeis_obrigatorios = [...new Set(restricoesBase.flatMap(r => PapelBusiness.papeisPorRestricao(r)))];
          const pObrigatorios1 = dto.tipoServico?.opcoes?.papeisObrigatorios?.find(p => papeis_obrigatorios.includes(p));
          if(!pObrigatorios1 && !dto.envolvidos.find(e => papeis_obrigatorios.includes(e.papel))){
            let nomes = papeis_obrigatorios.map(p => PapelBusiness.getNomePapel(p)).join(', ');
            FrontBusiness.showError('', `Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`);
            retorno = false;
          }
        }

        const papeisCompromisso = PapelBusiness.papeisPorRestricao('COMPROMISSO');
        const c2 = dto.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes('COMPROMISSO');
        const pObrigatorios2 = dto.tipoServico?.opcoes?.papeisObrigatorios?.find(p => papeisCompromisso.includes(p));
        if(c2 && !pObrigatorios2 && !dto.envolvidos.find(e => papeisCompromisso.includes(e.papel))){
          let nomes = papeisCompromisso.map(p => PapelBusiness.getNomePapel(p)).join(' ou ');
          FrontBusiness.showError('', `Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`);
          retorno = false;
        }

        const papeisDominio = PapelBusiness.papeisPorRestricao('DOMINIO');
        const c3 = dto.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes('DOMINIO');
        const pObrigatorios3 = dto.tipoServico?.opcoes?.papeisObrigatorios?.find(p => papeisDominio.includes(p));
        if(c3 && !pObrigatorios3 && !dto.envolvidos.find(e => papeisDominio.includes(e.papel))){
          let nomes = papeisDominio.map(p => PapelBusiness.getNomePapel(p)).join(', ');
          FrontBusiness.showError('', `Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`);
          retorno = false;
        }
      }

      return retorno;
    },

    validarLivroEstrangeiro(ato) {
      if (!ato.id && this.areas.filter(a => a.id === 'livro-estrangeiro').length === 0) {
        ato.observacaoLivroEstrangeiro = null;
        ato.livroEstrangeiro = null;
      }
    },

    isPactoAnteNupcial(ato){
      return this.ficha.livro === 'REGISTRO_AUXILIAR' && ato?.tipoServico?.opcoes?.tipoRegistro === 'PACTO';
    },

    async gerarDto(){

      let dto = {}, indices = {quantidade : 0, respondidos: 0}, exigencias = [];

      let checklistProcessado = await ChecklistProcessamentoBusiness.processarEntidade(this.form, this.checklist, 'ato', this.documentos, 'storage')

      if(checklistProcessado?.grupos?.length){
        indices = checklistProcessado.indices;
        exigencias = checklistProcessado.exigencias;
        indices.quantidade = checklistProcessado?.contador?.quantidade || 0;
        indices.respondidos = checklistProcessado?.contador?.respondidos || 0;
        exigencias = await ChecklistProcessamentoBusiness.copilarExigencias(this.protocolo, this.form, exigencias);
      }
      dto = Utils.clone({...this.form, indices, exigencias});
      dto.indicadorDocumentos = dto.indicadorDocumentos?.map(e => {
        e.tipoDocumento = {id: e.tipoDocumento.id || e.tipoDocumento};
        return e;
      });
      dto.indicadorGarantias = dto.indicadorGarantias?.map(e => {
        e.bemMovel = {id: e.bemMovel.id};
        return e;
      });
      return Utils.clone(dto);

    },

    async salvar() {
      await this.$refs?.checklist?.process();

      let validated = true;
      this.$set(this, 'validation', {});
      if (!this.form?.ficha?.id) {
        this.$refs.buscarFichas.mensagemValidacao = 'Campo obrigatório'
      }

      let dto = await this.gerarDto();

      if (dto.xmlAssinado) {
        const camposAlterados = [];
        if (String(dto.codigo || '') !== String(this.assinatura_old?.codigo || '')) camposAlterados.push('Código');
        if (String(dto.titulo || '') !== String(this.assinatura_old?.titulo || '')) camposAlterados.push('Título');
        if (String(dto.texto || '') !== String(this.assinatura_old?.texto || '')) camposAlterados.push('Minuta');

        if (camposAlterados.length > 0) {
          const result = await FrontBusiness.openConfirmacao(
            'Atenção! Você alterou um dos campos que compõem a assinatura do ato (' + camposAlterados.join(', ') + '). Ao continuar, o hash e o XML da assinatura serão removidos e será necessário realizar uma nova assinatura.',
            'Deseja continuar?'
          );
          if (result !== 'confirm') return false;
          dto.dto = dto.dto || {};
          dto.dto.removerAssinatura = true;
        }
      }

      await TipoServicoBusiness.exibirMensagemConfirmacaoTipoTribunal(dto.id, "ATO", dto);

      // let dto = Utils.clone(this.form);
      // dto.exigencias = await ChecklistProcessamentoBusiness.copilarExigencias(this.protocolo, this.form, this.form.exigencias);

      this.validarLivroEstrangeiro(dto);

      dto.tipo = dto.tipoServico?.opcoes?.tipoAto;
      dto.custasManual = dto.custasManual !== false ? true : false;

      dto.texto = textoFormatado(dto.texto);

      validated = this.validarRestricoes(dto);

      let obrigatorios = ['registro', 'codigo']; //, 'texto'
      if(!dto.legado){
        obrigatorios.push('tipoServico')
      }
      if ([undefined, null, ''].indexOf(dto['codigo']) === -1) dto['codigo'] = dto['codigo'] + '';
      obrigatorios.forEach(e => {
        if (!dto[e] || (Object.keys(dto[e]).length === 0 && dto[e].constructor === Object) || dto[e] === []) {
          this.$set(this.validation, e, 'Campo obrigatório');
          validated = false;
        }
      });
      let data = dto?.registroAuxiliar?.pacto;
      if (this.isPactoAnteNupcial(dto) && (Utils.isEmptyNullOrUndefined(data) || ((this.$moment(data).isAfter(this.$moment()) || !this.$moment(data).isValid() || data.split('-')[0] < '1850')))) {
        return FrontBusiness.showError('', 'Necessário informar uma data válida para o Pacto Antenupcial')
      }

      if (this.form.ficha.tipoImovel === 'OUTROS' && Utils.isEmptyNullOrUndefined(this.form.ficha.descricaoTipoImovelOutros) && !dto.legado) {
        return FrontBusiness.showError('', `Necessário informar a descrição do tipo de imóvel “Outros”`);
      }

      // dto.registro = new Date(dto.registro);
      // dto.selado = new Date(dto.selado);
      dto.livro = this.ficha?.livro;
      dto.protocolo = dto.protocolo?.id ? {id: dto.protocolo?.id} : null;
      dto.envolvidos = dto.envolvidos.length ? dto.envolvidos : null;

      if (dto.protocolo?.id) {
        dto.dto.salvandoItemProtocolo = true;
      }

      let countEnvolvidos = 0;
      let doitu = [];

      if (dto.envolvidos?.length) {

        dto.envolvidos?.forEach(e => {
          let papelValido = this.papeis.find(p => p.id === e.papel);
          if (!papelValido) countEnvolvidos++;
          if(this.form.ficha.imovelUniao){
            e.representantes?.forEach(representante=>{
              if(representante.documento && !representante.indicadorPessoalVersaoId){
                doitu.push("IMÓVEL DA UNIÃO [DOITU]: Necessário informar um nome para o representante ("+representante.documento +") do envolvido " + e.nome + ". Vincule um indicador pessoal no campo do representante")
              }
            })
          }
        })

        dto.envolvidos = dto.envolvidos?.map(e => ChecklistProcessamentoBusiness.limparObjetoEnvolvido(e, true));

      }

      if (countEnvolvidos > 0) return FrontBusiness.showError('', `Necessário informar o papel do${countEnvolvidos > 1 ? 's' : ''} envolvido${countEnvolvidos > 1 ? 's' : ''}`)
      if (doitu.length) {
        doitu.map(msg => {
          FrontBusiness.showError('', msg)
        })
        return
      }

      //Validar doi
      let validatedDto = await this.validarDoi(dto);
      if (validated && validatedDto) {

        switch (this.ficha.livro) {
          case 'REGISTRO_AUXILIAR':
            dto.registroAuxiliar = {id: this.form.ficha.id};
            dto.legado = !dto.id ? true : dto.legado;
            break;
          case 'MATRICULA':
          case 'TRANSCRICAO':
            dto.indicadorReal = {id : this.form.ficha.id };
            break;
          default:
            dto.indicador = {id : this.form.ficha.id,  tipoRegistro: this.form.indicador.tipoRegistro};
            break;
        }
        dto.tipoServico =  Utils.getObjectId(dto.tipoServico);
        dto.notificacao =  Utils.getObjectId(dto.notificacao);

        let atoId = await AtoLegadoBusiness.save(dto, this.form?.id).catch(this.showError);
        if (atoId) {
          FrontBusiness.showSuccess('', 'Ato salvo com sucesso');
          this.$set(this, 'alterouFicha', this.ficha.id != this.form.ficha.id);
          await this.verificarAlteracoes(true);
          if(!this.form?.id){
            this.$set(this.form, 'id', atoId);
          }
          this.assinatura_old = {
            codigo: dto.codigo,
            titulo: dto.titulo,
            texto: dto.texto
          };
          return true;
        }
      }
    },

    atualizarCardLivroEstrangeiro() {
      if (this.areas.filter(a => a.id === 'livro-estrangeiro').length === 0 || !this.form.id) {
        const ato = Utils.clone(this.form);
        ato.envolvidos = ato.envolvidos || [];
        ato.ficha = this.form.ficha || {};
        const areas = business.areasAto(ato);
        this.filtrarAreas(areas);
      }
    },

    async validarDoi(ato) {

      if(!ato.tipoServico?.id){
        return true;
      }

      let doiValida = true;

      if (ato.ficha?.imovelUniao && ato.tipoServico?.opcoes?.tipoTransacaoDoi !== 'NENHUM' && ato.doi?.gerarDoi && Utils.isEmptyNullOrUndefined(ato.doi?.tipoTransacaoDoitu)){
        doiValida = false;
        FrontBusiness.showError('', `IMÓVEL DA UNIÃO [DOITU]: Necessário informar o tipo de transação do ato`);
      }

      let indicadorReal = IndicadorBusiness.getLivro(ato?.livro).grupo == 'INDICADOR_REAL';
      let indicador = ato.indicador && ato.indicador.livro === 'REGISTRO_TD' && ato.indicador.tipoRegistro !== 'REGISTRO_INSCRICAO';
      let mostrarDoi = indicadorReal || indicador;

      if (ato.tipoServico?.opcoes?.tipoTransacaoDoi === 'NENHUM' && indicadorReal && ato?.tipoServico?.opcoes?.tipoAto === 'ABERTURA') {
        try {
          await AtoLegadoBusiness.validarEnvolvidosDOI(ato.envolvidos, ato);
        } catch (e) {
          FrontBusiness.showError('', e);
          doiValida = false;
        }
      }

      if (ato.tipoServico?.opcoes?.tipoTransacaoDoi !== 'NENHUM' && mostrarDoi) {

        if (ato.doi?.gerarDoi) {

          ato.doi = ato.doi || {};

          if (indicadorReal && !ato.doi?.situacaoConstrucao) {
            doiValida = false;
            FrontBusiness.showError('', `Necessário informar a situação da construção`);
          }

          if (!ato.doi?.formaAlienacao) {
            doiValida = false;
            FrontBusiness.showError('', `Necessário informar a forma de alienação para a DOI`);
          }

          if (!ato.doi?.dataAlienacao || (moment(ato.doi?.dataAlienacao).isAfter(moment()) || !moment(ato.doi?.dataAlienacao).isValid() || (ato.doi?.dataAlienacao && ato.doi?.dataAlienacao.split('-')[0] < '1850'))) {
            doiValida = false;
            FrontBusiness.showError('', `DOI - Necessário preencher o campo “Data da alienação” com uma data válida`);
          }

          if (ato.doi?.formaAlienacao === 'A_PRAZO' && (!ato.dto?.valoresBaseCalculo?.alienacao || ato.dto?.valoresBaseCalculo?.alienacao === '0')) {
            doiValida = false;
            FrontBusiness.showError('', `Necessário informar um valor de alienação para a DOI`);
          }

          let isRtd = ato.indicador && ato.indicador.livro === 'REGISTRO_TD' && ato.indicador.tipoRegistro !== 'REGISTRO_INSCRICAO';
          let exibirCamposRtd = isRtd && ['COMPRA_E_VENDA', 'TITULO_DOMINIO', 'CESSAO_DE_DIREITOS'].includes(ato.tipoServico?.opcoes?.tipoTransacaoDoi);
          if (exibirCamposRtd) {
            let tipoVinculo = ato.doi?.tipoVinculoDoi;
            let registroVinculado = tipoVinculo === 'INDICADOR_REAL_EXTERNO'
              ? ato.indicadorRealExternoVinculado
              : ato.indicadorRealDoiVinculado;
            if (!tipoVinculo || !registroVinculado) {
              doiValida = false;
              FrontBusiness.showError('', 'DOI - Necessário preencher o campo "Vínculo"');
            }
          }

          if (ato.doi?.editarInformacao) {
            let campos = ['descricaoImovel'];
            if(ato.doi?.alienacaoConsta !== 'VALOR_NAO_CONSTA_NOS_DOCUMENTOS') {
              campos = [...campos, ...['valorAlienacao']];
            }
            if(ato.doi?.itbiConsta !== 'VALOR_NAO_CONSTA_NOS_DOCUMENTOS') {
              campos = [...campos, ...['valorAvaliacao']];
            }
            if(indicadorReal && ato.doi?.areaConsta !== 'AREA_NAO_CONSTA_NOS_DOCUMENTOS') {
              campos = [...campos, ...['area']];
            }
            let camposVazios = campos.filter(key => (ato.doi[key] === null || ato.doi[key] === undefined));
            if (camposVazios.length) {
              doiValida = false;
            }
          }

          try {
            await AtoLegadoBusiness.validarEnvolvidosDOI(ato?.envolvidos, ato);
          } catch (e) {
            FrontBusiness.showError('', e);
            doiValida = false;
          }

          for (let e of ato.envolvidos) {
            if(AtoLegadoBusiness.getPapeisTransmitente().includes(e.papel) || AtoLegadoBusiness.getPapeisAdquirente().includes(e.papel)) {
              if ((e.indicadorPessoalVersao?.documentoDesconhecido || (!e.indicadorPessoalVersao?.documentoDesconhecido && !e.indicadorPessoalVersao?.documento)) && !e.representantes) {
                if(ato.tipoServico.opcoes.permitirEnvolvidoSemDocumento){
                  FrontBusiness.showWarn('', `Necessário informar um ${e.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} ou um representante para o envolvido ${e.nome}`)
                } else {
                  doiValida = false;
                  FrontBusiness.showError('', `Necessário informar um ${e.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} ou um representante para o envolvido ${e.nome}`)
                }
              }
            }

            let msgDocInvalidoEnvolvido = await IndicadorPessoalBusiness.validarDocumentos(e.tipoPessoa, e.indicadorPessoalVersao?.documento);

            if(e.indicadorPessoalVersao?.documento && msgDocInvalidoEnvolvido) {
              doiValida = false;
              FrontBusiness.showError('', `O ${e.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} informado para o envolvido ${e.indicadorPessoalVersao.nome} é inválido`);
            }
            if(e.representantes){
              for (const representante of e.representantes) {
                if(representante.documento) {
                  let docLimpo = representante.documento.replace(/[^a-zA-Z0-9]/g, '');
                  let tipoRepresentante = docLimpo.length === 11 ? 'FISICA' : docLimpo.length === 14 ? 'JURIDICA' : null;
                  if(!tipoRepresentante) {
                    doiValida = false;
                    FrontBusiness.showError('', `O documento (${representante.documento}) do representante informado para o envolvido ${e.indicadorPessoalVersao.nome} é inválido`);
                  } else {
                    let msgDocInvalidoProcurador = await IndicadorPessoalBusiness.validarDocumentos(tipoRepresentante, representante.documento);
                    if(msgDocInvalidoProcurador) {
                      doiValida = false;
                      FrontBusiness.showError('', `O ${tipoRepresentante === 'FISICA' ? 'CPF' : 'CNPJ'} (${representante.documento}) do representante informado para o envolvido ${e.indicadorPessoalVersao.nome} é inválido`);
                    }
                  }
                }
              }
            }

          }

        }

      } else {
        ato.doi = {};
        this.$set(this.form, 'doi', {});
      }

      return doiValida;

    },

    getStaticDoi() {
      return {gerarDoi: true};
    },

    getDoiDTO(ato) {
      let possuiAreaDoi = business.areasAto(ato).filter(a => a.id === 'doi').length > 0;
      if (!possuiAreaDoi && !ato.id) {
        ato.doi = this.getStaticDoi();
      }
      if (ato.doi && ato.doi.gerarDoi == undefined) {
        ato.doi.gerarDoi = possuiAreaDoi;
      }
      return ato.doi || this.getStaticDoi();
    },

    async getCamposAdicionais(ato) {

      if(ato.tipoServico?.regraCustas){
        ato.camposAdicionais = await RegraCustasBusiness.getRegra(ato.tipoServico.regraCustas).catch(e => null);
      }
      if (!this.areas.includes('emolumentos') && !ato.id) {
        ato.dto.camposAdicionais = {};
      }
      return ato.dto.camposAdicionais || {};
    },

    async getProcurador() {
      await this.form.envolvidos.map(async envolvido => {
        this.$set(envolvido, 'exibicao', this.procuradorExibicao(envolvido));
        this.$set(envolvido, 'procuradorVersao', envolvido.procuradorVersao || {});
        this.$set(envolvido, 'editandoProcurador', await this.validarDocumentos(envolvido, true));
      });
    },

    procuradorExibicao(envolvido) {
      return `${envolvido?.procuradorVersao?.nome ? `${envolvido?.procuradorVersao?.nome} - ` : ''}${envolvido.procurador}`;
    },

    editProcurador(envolvido) {
      this.$set(envolvido, 'editandoProcurador', !envolvido.editandoProcurador);
    },

    async selecionarProcurador(envolvido, indicador) {
      this.$set(envolvido, 'procurador', indicador?.documento);
      this.$set(envolvido, 'procuradorVersao', {id: indicador?.id, nome: indicador?.nome});
      this.$set(envolvido, 'exibicao', this.procuradorExibicao(envolvido));
      await this.validarDocumentos(envolvido)
      if (!indicador) this.$set(envolvido, 'procuradorDocumentoInvalido', null);
    },

    async validarDocumentos(envolvido, selecao = true) {
      let documentoProcurador = envolvido.procurador;
      if (!selecao) documentoProcurador = this.$refs.buscar[0].query;
      let msgDocInvalido = await IndicadorPessoalBusiness.validarDocumentos('FISICA', documentoProcurador);

      if (!selecao) {
        this.$set(envolvido, 'procurador', documentoProcurador);
        this.$set(envolvido, 'procuradorVersao', {});
        this.$set(envolvido, 'exibicao', this.procuradorExibicao(envolvido));
      }

      if (msgDocInvalido == null || (msgDocInvalido && (documentoProcurador == null || documentoProcurador == ""))) {
        this.$set(envolvido, 'procuradorDocumentoInvalido', null);
      } else {
        this.$set(envolvido, 'procuradorDocumentoInvalido', msgDocInvalido);
      }
    },

    changeEditor(e, campo, focus) {
      for (let checklist of (this.$refs?.checklist || [])) {
        checklist?.montarChecklist(e, campo, focus);
      }
    },

    async atualizarChecklists() {
      await this.tratarChecklist();
      this.$forceUpdate();
    },

    async tratarChecklist() {
      this.indices = this.form?.indices || {};
      this.checklist = await ChecklistProcessamentoBusiness.getChecklists(this.form, 'ato');
      this.checklistEnvolvidos = await ChecklistProcessamentoBusiness.getChecklists(this.form, 'envolvidos');
    },

    checkDate(campo) {
      if(new Date(this.form[campo]) > new Date(this.today)) {
        FrontBusiness.showError('', 'A data de ' + (campo == 'registro' ? 'Registro' : 'Selagem') + ' não pode ser maior que a data atual');
        this.$set(this.form, campo, null);
      }
      if (campo === 'selado') {
        if(new Date(this.form[campo]) < new Date(this.form['registro'])) {
          FrontBusiness.showError('', 'A data de Selagem não pode ser menor que a data de Registro');
          this.$set(this.form, campo, null);
        }
      }
      if (campo === 'registro') {
        if(new Date(this.form[campo]) > new Date(this.form['selado'])) {
          FrontBusiness.showError('', 'A data de Registro não pode ser maior que a data de Selagem');
          this.$set(this.form, campo, null);
        }
      }
    },



    async confirmarSalvarAlteracoes() {
      this.copiarAto = false;
      let result = await FrontBusiness.showConfirmacao("Você possui alterações no ato", "Deseja salvar?").then(async r => {
        if (r.value) {
          return await this.salvar();
        } else if (r.dismiss === 'cancel') {
          return false;
        } else {
          return true;
        }
      }).catch(this.showError);

      return result
    },

    limparDto(dto) {
      Object.keys(dto?.indices || {}).forEach(e => {
        if (Utils.isEmptyNullOrUndefined(dto?.indices?.[e]) || (!dto?.indices?.[e].length) || !(Object.keys(dto?.indices?.[e] || {}).length)) {
          delete dto?.indices?.[e];
        }
      })
      delete dto?.indices?.checklistProcessado;
      Object.keys(dto?.dto?.valoresBaseCalculo || {}).forEach(e => {
        if (Utils.isEmptyNullOrUndefined(dto?.dto?.valoresBaseCalculo?.[e])) {
          delete dto?.dto?.valoresBaseCalculo?.[e];
        }
      })
      if (Utils.isEmptyNullOrUndefined(dto?.dto?.valoresMultiplasCobrancas) || !dto?.dto?.valoresMultiplasCobrancas.length) {
        delete dto?.dto?.valoresMultiplasCobrancas;
      }
      if (Utils.isEmptyNullOrUndefined(dto?.dto?.restricoesCanceladasSemRegistrar) || !dto?.dto?.restricoesCanceladasSemRegistrar.length) {
        delete dto?.dto?.restricoesCanceladasSemRegistrar;
      }
      if (Utils.isEmptyNullOrUndefined(dto?.dto?.restricoesCanceladas) || !dto?.dto?.restricoesCanceladas.length) {
        delete dto?.dto?.restricoesCanceladas;
      }
      delete dto?.dto?.restricoesCanceladasDisponiveis;
      if (Utils.isEmptyNullOrUndefined(dto?.dto?.restricoesReativadas) || !dto?.dto?.restricoesReativadas.length) {
        delete dto?.dto?.restricoesReativadas;
      }

      if (Utils.isEmptyNullOrUndefined(dto?.ressarcimento) || !dto?.ressarcimento.length) {
        delete dto?.ressarcimento;
      }
      Utils.orderFields(dto?.envolvidos, ['ordem', 'nome']);
      (dto?.envolvidos || []).map((e, i) => {
        e.ordem = i + 1
      })
      return dto
    },

    async verificarAlteracoes(armazenar) {
      let dto = Object.freeze(Utils.clone(this.limparDto(await this.gerarDto())));
      if(!this.form_old || armazenar){
        this.form_old = dto;
      }

      if(armazenar){
        return false;
      }

      let changed = !Utils.isEqual(dto, this.form_old);
      if(changed){
        console.debug('verificarAlteracoes', Utils.deepDiff(dto, this.form_old), !Utils.isEqual(dto, this.form_old));
      }

      return changed;
    },

    async gerarTexto(){
      let salvar = false;
      if (await this.verificarAlteracoes()) {
        salvar = await this.confirmarSalvarAlteracoes();
      } else {
        salvar = true;
      }

      if(salvar) {
        const modal = IndicadorBusiness.getSimulacaoIndicador(this.form.ficha.livro);

        let protocolo = this.form.protocolo;
        try {
          const protocoloCompleto = await protocoloBusiness.getById(this.form.protocolo?.id);
          if (protocoloCompleto) {
            protocolo = protocoloCompleto;
          }
        } catch (e) {
          // mantém protocolo resumido se a consulta falhar ou o ID for inválido
        }

        let retorno = await FrontBusiness.openModal(modal, {
          ato: this.form?.id,
          id: this.form?.ficha.id,
          protocolo: protocolo
        });

        if (retorno) {
          if (!this.form.texto) {
            this.$set(this.form, 'texto', retorno.minuta);
          } else {
            let change = await FrontBusiness.openModal(ModalCompararTexto, {
              original: this.form.texto,
              novo: retorno.minuta
            });
            if (change) {
              this.$set(this.form, 'texto', retorno.minuta);
            }
          }
        }
      }
    },

    async consultarModelos(){
      let modelo = await FrontBusiness.openModal(ModalSelecionarModeloTextual, {tipo : 'ATO', dominio: this.dominio});
      this.insertContent(modelo.texto);
    },

    async consultarQualificacoes(){
      let modelo = await FrontBusiness.openModal(ModalInserirQualificacao,
        {envolvidos : this.form?.envolvidos?.map(e => ({id : e.indicadorPessoalVersao.id}))}
      );
      this.insertContent(modelo);
    },

    insertContent(text){
      if(text){
        this.$refs.editorminuta?.$refs?.editortexto?.editor?.insertContent(text);
      }
    },

    selecionarFichas(fichas) {
      this.$set(this.form, 'ficha', fichas ? fichas[0] : null);
      if(!this.form.ficha){
        this.$refs.buscarFichas.limparCampos();
      }
    },

    async pesquisandoFicha(pesquisando) {
      await this.$set(this, 'pesquisando', pesquisando);
    }
  }
}
</script>

<style lang=scss>
#detalhes-ato {
  .modal-body {
    height: calc(100vh - 150px);
  }
}
</style>
